module.exports = __webpack_public_path__ + "static/business-valuation-cab4234ccabb02e397f67d2edaedaf8c.png";